import React from 'react';
import { CaregiverProfile } from '../../../types/index';
import InfoItem from './InfoItem';
import { LocationIcon, VerifiedIcon, NationalityIcon, MaritalStatusIcon, AgeIcon, GenderIcon } from '../../../components/common/Icons';

interface ProfileSummaryProps {
  profile: CaregiverProfile;
}

const ProfileSummary: React.FC<ProfileSummaryProps> = ({ profile }) => {
  return (
    <div className="p-4 p-md-5 text-center text-lg-start">
      <div 
        className="profile-image-container rounded-circle mx-auto mx-lg-0 d-flex justify-content-center align-items-center" 
        style={{ backgroundColor: 'var(--accent-yellow)' }}>
        <img
          src={profile.imageUrl}
          alt={profile.name}
          className="profile-image rounded-circle"
        />
      </div>
      <h1 className="h4 fw-bold text-dark mt-4 mb-1">{profile.name}</h1>
      <p className="text-primary fw-medium mb-2">{profile.tagline}</p>
      
      <div className="d-flex align-items-center justify-content-center justify-content-lg-start mt-3 text-muted small">
        <LocationIcon style={{ height: '1rem', width: '1rem' }} className="me-2 flex-shrink-0" />
        <span>{profile.location}</span>
      </div>

      {profile.isVerified && (
        <div className="d-flex align-items-center justify-content-center justify-content-lg-start mt-2 text-primary small fw-semibold">
          <VerifiedIcon style={{ height: '1rem', width: '1rem' }} className="me-2 flex-shrink-0" />
          <span>Verified Professional</span>
        </div>
      )}
      
      <hr className="my-4" />

      <div className="d-flex flex-column gap-3">
        <InfoItem icon={<NationalityIcon />} label="Nationality" value={profile.nationality} />
        <InfoItem icon={<MaritalStatusIcon />} label="Marital Status" value={profile.maritalStatus} />
        <InfoItem icon={<AgeIcon />} label="Age" value={profile.age.toString()} />
        <InfoItem icon={<GenderIcon />} label="Gender" value={profile.gender} />
      </div>
    </div>
  );
};

export default ProfileSummary;
